/* eslint-disable no-empty */
/* eslint-disable spaced-comment */

import axios from 'axios';
import { HttpService } from '../HttpService';
import { getSecureBaseUrl, getBaseUrl, getBaseUrlOfNTAS, getBaseUrlOfAuthToken } from '../UrlMapperService';
import * as Constants from './Constants';
import { store } from '../../configureStore';
import { apiUrls } from '../../constants/apiUrl';

import {
  getIntendType,
  getCookie,
  isMoversFlow,
  getSession,
  setSession,
  setCookie,
  getAPPID,
  getBundleCategory,
  isExpressCheckout,
  isPreorder,
  isBulkQualIndicator,
  buildUpdateProcessStepPayload,
  isWHW,
  isSequentialFlow,
  getFlowTypeWithIntend,
  viewport,
  isJointTransactionFlow,
  getJointTransactionLine,
  getPageName,
  isWHWP2,
  isWWM,
  isECJointTransactionFlow,
  isDeviceUpgradeFlow,
  getLqDetails,
  getUrlName,
  isTitanOneUpgradeFlag,
  prefetchGetShippingOptionsCookie,
  prefetchConditions,
  getTransactionLine,
  skipProspectExpressCheckout,
  isStreamlineFlow,
  isJTFlowFromNGDCart,
  showContactInfoForWifiBackupFFlag,
} from '../../components/common/Helpers/index';
import getCartDetails_5G from '../../assets/cq/getCartDetails_5G.json';
import getCartDetails_LTE from '../../assets/cq/getCartDetails_LTE.json';
import { bundleInstallType, getCartUpdtApiObj } from '../../pages/ExpressCart/actions';
import { hideLoader } from '../../components/common/Helpers/loader';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { safetechInit } from '../../components/common/Helpers/safetech';
import { getQueryParamByName } from '../../components/common/Helpers/queryParams';
import { isAppointmentSetupEnabled } from '../../components/common/Helpers/sessionUtils';
import { wifiTransactionType } from '../../components/common/Helpers/constants';

const commonHeader = { flowName: `${getFlowTypeWithIntend()}` };

const whwFlag = () => !isWWM() && !isTitanOneUpgradeFlag() && !isDeviceUpgradeFlow();

export const getCartDataFromApi = (data) => ({
  type: Constants.GET_CART_DETAILS_FROM_API,
  data,
});

export const getShowCartStatus = (data) => ({
  type: 'SHOW_SAVE_CART',
  data,
});
export const updateCartDetails = (data) => ({
  type: 'UPDATE_CART_DETAILS',
  data,
});

export const fetchAutoFillAddress = (data) => ({
  type: Constants.FETCH_AUTOFILL_ADDRESS,
  data,
});

export const fetchAutoFillAddressUnit = (data) => ({
  type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT,
  data,
});

export const fetchAutoFillAddressUnit2 = (data, value) => ({
  type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT2,
  data,
  value,
});

export const apiConfigCall = () => ({
  type: Constants.FETCH_APICONFIG,
});

export const getAuthorizationToken = () => ({
  type: 'FETCH_AUTH_TOKEN_FOR_NTAS_API',
});

export const getCheckoutOrderDetails = (data) => ({
  type: Constants.CHECKOUT_DETAILS,
  data,
});

export const getAuthorizationTokenAPICall = () => {
  const apiUrl = `${getBaseUrlOfAuthToken()}${apiUrls().generateToken}`;
  return axios({
    url: apiUrl,
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

export const fetchAutoFillSearch = (data) => {
  const { useTypeAheadSoeUrl } = window.vzFlags;

  if (useTypeAheadSoeUrl) {
    const postData = { streetterm: data };
    return HttpService.post(`${getSecureBaseUrl()}${apiUrls().addressAutoFillSoeUrl}`, postData);
  }
  const searchTerm = encodeURIComponent(data);
  const { baseUrl, apiKey, queryParam } = getBaseUrl(data);
  const apiUrl = `${baseUrl}${apiUrls().addressAutoFillUrl}?streetterm=${searchTerm}&countrycode=USA${queryParam}`;
  return axios({
    url: apiUrl,
    method: 'GET',
    headers: {
      ApiKey: apiKey,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response)
    .catch((error) => error);
};

export const get5GAppConfig = () => {
  // const { isOnlyTypeAhead } = window.vzFlags;
  // const postData = {
  //   Flag: isOnlyTypeAhead
  // };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().get5GAppConfigFlag}`;
  return HttpService.post(apiURL);
};

export const fetchUnitDetails = (data) => {
  const { isOnlyTypeAhead } = window.vzFlags;
  let OnlyTypeAhead = false;
  if (isOnlyTypeAhead === 'yes' || isOnlyTypeAhead === 'app' || isOnlyTypeAhead === 'no') {
    OnlyTypeAhead = true;
  } else {
    OnlyTypeAhead = false;
  }
  const locationIdSession = getSession('locationId');
  // const { apiKey, baseUrl } = getBaseUrl(data);

  if (OnlyTypeAhead) {
    const postData = { baseAddressId: data.value || locationIdSession, unitterm: data.data, size: 10 };
    // const apiResponse = HttpService.post(`${baseUrl}${apiUrls().addressAutoFillUnitUrl}?locusID=${locationIdSession}&unitterm=${data}&size=10`);
    return HttpService.post(`${getSecureBaseUrl()}${apiUrls().addressAutoFillUnitSoeUrl}`, postData);
  }
  // const locusID = encodeURIComponent(data);
  // const apiUrl = `${baseUrl}${apiUrls().addressAutoFillUnitUrl}?locusID=${locusID}&unitterm=${data}&size=10`;
  // // const apiUrl = `${baseUrl}${apiUrls().addressAutoFillUnitUrl}`;
  // return axios({
  //   url: apiUrl,
  //   method: 'GET',
  //   headers: {
  //     ApiKey: apiKey,
  //     'Content-Type': 'application/json',
  //   },
  // })
  //   .then((response) => response)
  //   .catch((error) => error);
};
export const fetchAutoFillSearchUnit = (data) => {
  // debugger;
  const { useTypeAheadSoeUrl } = window.vzFlags;

  if (useTypeAheadSoeUrl) {
    const postData = { baseAddressId: data, size: 10 };
    return HttpService.post(`${getSecureBaseUrl()}${apiUrls().addressAutoFillUnitSoeUrl}`, postData);
  }
  const locusID = encodeURIComponent(data);
  const { baseUrl, apiKey } = getBaseUrl(data);
  const apiUrl = `${baseUrl}${apiUrls().addressAutoFillUnitUrl}?locusID=${locusID}&size=10`;
  return axios({
    url: apiUrl,
    method: 'GET',
    headers: {
      ApiKey: apiKey,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response)
    .catch((error) => error);
};

export const ntasAutoFillSearch = (data) => {
  const searchTerm = encodeURIComponent(data.request);
  const { baseUrl } = getBaseUrlOfNTAS();
  const apiUrl = `${baseUrl}${apiUrls().ntasAddressUrl}?streetterm=${searchTerm}`;
  return axios({
    url: apiUrl,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${data.authToken}`,
    },
  })
    .then((response) => response)
    .catch((error) => error);
};

export const updateSaveCart = (data) => ({
  type: 'SAVE_CART',
  data,
});

export const updateCartAALSuccessFalgReset = (data) => ({
  type: 'UPDATE_CART_AAL_SUCCESS_FLAG_RESET',
  data,
});

export const showCart = (data) => ({
  type: 'SHOWCART',
  data,
});

export const getAutoPayText = (data) => ({
  type: Constants.AUTOPAY_TEXT,
  data,
});

export const showPage = (data) => {
  store.dispatch({ type: Constants.SHOW_PAGE, data });
};

export const updateFlowTypes = (orderDetailsView) => {
  const { lineActivityType, networkBandwidthType } = orderDetailsView || {};
  if (lineActivityType) {
    if (networkBandwidthType && (networkBandwidthType === 'CBD' || networkBandwidthType === 'MMW' || networkBandwidthType === 'LTE')) {
      setSession('isCBandFlow', 'Y');
      if (networkBandwidthType === 'CBD') {
        setSession('isCBandQual', 'Y');
        setSession('FlowType', '5G');
      } else {
        setSession('FlowType', lineActivityType.includes('5G') && lineActivityType !== 'EUP_5G' ? '5G' : 'LTE'); // added EUP_5G check for setting Flowtype as 'LTE'
      }
    } else {
      setSession('FlowType', lineActivityType.includes('5G') ? '5G' : 'LTE');
    }
    if (!(getAPPID() === 'AAL')) {
      setCookie('loggedIn', lineActivityType.includes('AAL') ? 'true' : 'false');
    }
  }
};

export const getCartDetails = async (data = {}) => {
  const { pageName = '', validCouponResponse, FROM = '', prefetchValidateCart = '' } = data;
  let giftCardAccessoryRemovalNeeded = false;
  try {
    const flowType = getSession('FlowType');
    const mock = getSession('mock');
    let apiResponse = '';
    store.dispatch({ type: Constants.SET_CART_ERROR_FOR_REVIEW_ORDER_PAGE, response: false });
    if (mock) {
      if (flowType === '5G') {
        apiResponse = getCartDetails_5G;
        store.dispatch({ type: Constants.GET_CART_SUCCESS, response: apiResponse });
      } else if (flowType === 'LTE') {
        apiResponse = getCartDetails_LTE;
        store.dispatch({ type: Constants.GET_CART_SUCCESS, response: apiResponse });
      }
    } else {
      let postData = buildCartPayload(pageName, prefetchValidateCart);
      if (
        getPageName() === 'reviewOrder' &&
        store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.installType === 'Professional SetUp' &&
        isAppointmentSetupEnabled()
      ) {
        postData = { ...postData, data: { ...postData.data, validateAppointments: true } };
      }
      apiResponse = HttpService.post(`${getSecureBaseUrl()}${apiUrls().getCartDetailsurl}`, postData);
      // debugger;
      await Promise.all([apiResponse]).then((res) => {
        if (
          FROM === 'ABANDON_CART_SUCCESS' &&
          res?.[0]?.data?.dueTodayList?.some((ele) => ele.giftCard) &&
          !res?.[0]?.data?.orderDetailsView?.fwaSWOfferApplied
        ) {
          giftCardAccessoryRemovalNeeded = true;
        } else if (res[0] && res[0].data && !res[0].data?.errors && res[0].status === 200) {
          const { orderDetailsView } = res[0]?.data || {};
          if (orderDetailsView?.safeTechSessionId && window.location.href.includes('orderreview')) {
            safetechInit(orderDetailsView.safeTechSessionId);
          }
          if (pageName === 'cart') {
            store.dispatch({ type: Constants.ENABLE_CNT_BTN, response: true });
            // store.dispatch({ type: 'CALL_PERFORMANCE', response: 60 });
          }
          if (pageName === 'editFromCart') {
            // store.dispatch({ type: 'CALL_NBS_API', response: true });
            // to make a nbs call again if any update happens in cart page
            store.dispatch({ type: 'NBS_UPDATE', response: false });
          }
          //in resume cart set preorder in session if it is applicable for preorder
          if (!isPreorder()) {
            if (
              orderDetailsView &&
              orderDetailsView.networkBandwidthType &&
              orderDetailsView.networkBandwidthType === 'MMW' &&
              orderDetailsView.preOrderInServiceDate &&
              orderDetailsView.preOrderInServiceDate !== ''
            ) {
              setSession('isPreorder', true);
              // Resume Flow, Since session was set in UI, need a froce reload to read the session for header
              // window.location.reload();
              store.dispatch({ type: Constants.PREORDER, response: true });
            }
          }
          if (!getSession('FlowType')) {
            updateFlowTypes(res[0].data?.orderDetailsView);
          }
          if (isSequentialFlow()) {
            if (res[0]?.data?.customerProfileForNSE) {
              const { contactInfo } = res[0]?.data?.customerProfileForNSE;
              const { billingAddress } = contactInfo;
              const mobilityUserData = {
                address: {
                  addressLine1: billingAddress?.addressLine1 ? billingAddress?.addressLine1 : '',
                  addressLine2: billingAddress?.addressLine2 ? billingAddress?.addressLine2 : '',
                  city: billingAddress?.city ? billingAddress?.city : '',
                  countryCode: billingAddress?.countryCode ? billingAddress?.countryCode : '',
                  county: billingAddress?.county ? billingAddress?.county : '',
                  emailId: billingAddress?.emailId ? billingAddress?.emailId : '',
                  fipsCode: billingAddress?.fipsCode ? billingAddress?.fipsCode : '',
                  firstName: billingAddress?.firstName ? billingAddress?.firstName : '',
                  lastName: billingAddress?.lastName ? billingAddress?.lastName : '',
                  phoneNumber: billingAddress?.phoneNumber ? billingAddress?.phoneNumber : '',
                  state: billingAddress?.state ? billingAddress?.state : '',
                  streetDirection: billingAddress?.streetDirection ? billingAddress?.streetDirection : '',
                  streetName: billingAddress?.streetName ? billingAddress?.streetName : '',
                  streetNumber: billingAddress?.streetNumber ? billingAddress?.streetNumber : '',
                  type: billingAddress?.type ? billingAddress?.type : '',
                  zipCode: billingAddress?.zipCode ? billingAddress?.zipCode : '',
                  zipCode4: billingAddress?.zipCode4 ? billingAddress?.zipCode4 : '',
                },
                contactPersonPhone: contactInfo?.contactNumber ? contactInfo?.contactNumber : '',
                emailId: contactInfo?.email ? contactInfo?.email : '',
                firstName: contactInfo?.firstName ? contactInfo?.firstName : '',
                lastName: contactInfo?.lastName ? contactInfo?.lastName : '',
              };
              store.dispatch({ type: Constants.UPDATE_USER_DATA, response: mobilityUserData });
            }
          }
          store.dispatch({ type: Constants.GET_CART_SUCCESS, response: res[0].data });
          if (res && res.length > 0 && res[0].data && !res[0].data.errors) {
            store.dispatch({ type: 'LOADING_DONE', response: true });
            store.dispatch({ type: 'UPDATE_API_STATUS', response: 'COMPLETED' });
            if (prefetchValidateCart === 'prefetechOrderReviewValCart') {
              store.dispatch({ type: 'PREFETCH_ORDERREVIEW_STATUS', response: 'COMPLETED' });
            }
            store.dispatch({ type: 'API_LOADED', response: true });
          }
          if (
            getPageName() === 'reviewOrder' &&
            res &&
            res.length > 0 &&
            res[0]?.data?.cartValidationErrors?.find((obj) => obj?.errorCode === '2211')
          ) {
            store.dispatch({ type: Constants.SET_CART_ERROR_FOR_REVIEW_ORDER_PAGE, response: true });
          }
          if (pageName === 'orderConfirmation') {
            store.dispatch({ type: Constants.CONFIRMATION_RETRIEVE_CART, response: true });
          } else {
            store.dispatch({ type: Constants.CONFIRMATION_RETRIEVE_CART, response: false });
          }

          // if(validCouponResponse?.serviceBody?.serviceResponse?.context?.cartInfo?.statusCode == 1) {
          //   debugger;
          //   store.dispatch({ type: 'CLEAR_COUPON_VALUE'});
          // }
          // If there is no coupin in retrievecart then check if validCouponResponse is available with sucuess then clear
          if (!res[0]?.data?.cartHeader?.redemptionCode && validCouponResponse?.serviceBody?.serviceResponse?.context?.cartInfo?.statusCode === 1) {
            // debugger;
            store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
          }
          // debugger;
          //hideLoader();
          return res;
        }
        if (res[0] && (res[0]?.data?.errors || res[0]?.request?.status !== 200)) {
          const errorDetails = true;
          if (res[0]?.data?.loggerData) res[0].data.loggerData.note = `getCartDetails ${res[0]?.data?.loggerData.note}`;
          logger(res[0]?.data?.loggerData);
          store.dispatch({ type: 'UPDATE_API_STATUS', response: 'FAILED' });
          store.dispatch({ type: 'CEF_CART_ERROR', response: true, errorMessage: res[0]?.data?.errors?.[0]?.notifyMessage });
          store.dispatch({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          return res;
        }
        hideLoader();
      });
    }
  } catch (error) {
    // debugger;
  }
  if (FROM === 'ABANDON_CART_SUCCESS') {
    return giftCardAccessoryRemovalNeeded;
  }
};

export const updateChoiceRedirect = (redirectURL) => () => {
  window.location.href = redirectURL;
};

export const postAddToCart = (data, actionType, oddOnList = [], updateType = '', pageName = '', payLoadObj = undefined, cb = () => {}) => ({
  type: 'ADD_ACCESSORIES',
  data,
  actionType,
  oddOnList,
  updateType,
  pageName,
  payLoadObj,
  cb,
});
export const postAddToCartMV = (data, actionType) => ({
  type: 'ADD_ACCESSORIES_MV',
  data,
  actionType,
});

export const AddonAccessory = (data, actionType, oddOnList = [], updateType = '', pageName = '', cb = () => {}) => ({
  type: 'ADD_ON_ACCESS',
  data,
  actionType,
  oddOnList,
  updateType,
  pageName,
  cb,
});

export const getAddAccessories = (value) => {
  let removeAccessories = value.removeAccessories && [
    {
      id: value.removeAccessories ? value.removeAccessories.prodId : '',
      qty: value.removeAccessories ? value.removeAccessories.qty : '',
      isSoftSku: false,
      accessoryBundle: false,
    },
  ];
  // const WHW = value.AddonAccessory && [
  //  {
  //    offerId: "12345",
  //   offerType: "EXTENDER",
  //   billingProductId: "9234234",
  // },
  // ];
  let addAccessories = value.addAccessories && [
    {
      id: value.addAccessories ? value.addAccessories.prodId : '',
      qty: value.addAccessories ? value.addAccessories.qty : '',
      isSoftSku: false,
      accountLevelAccessory: false,
    },
  ];
  const joint = isJointTransactionFlow() || isECJointTransactionFlow();
  const line = joint ? `${getJointTransactionLine()}` : 'newLine1';
  let postData = {
    cartInfo: {
      correlationId: '',
      processingMTN: line,
      processStep: 'Accessories',
      cartCreator: '',
      processAction: 'addAccessory',
      intendType: `${getIntendType()}`,
      intent: `${getIntendType()}`,
      creditAppNum: '',
    },
    data: {
      depletionType: value.depletionType,
      lines: [
        {
          mtn: line,
          mdnFilterValue: line,
          removeAccessories,
          addAccessories,
          ispuFlow: false,
          depletionLocationCode: '',
        },
      ],
    },
  };
  if (value === 'WHW') {
    postData = {
      cartInfo: {
        correlationId: '',
        processingMTN: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
        processStep: 'AccessoryPDP',
        cartCreator: '',
        processAction: 'addAccessoryAndCheckout',
        intendType: 'ACC',
        intent: `RedemptionAccessory`,
        creditAppNum: '',
        flowType: 'WHW_Redemption',
      },
      data: {
        depletionType: 'F',
        lines: [
          {
            mtn: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
            mdnFilterValue: '',
            addAccessories: [
              {
                qty: '1',
                isSoftSku: false,
                accessoryBundle: false,
                giftCard: false,
                category: 'Gaming & Toys',
                productId: '',
                accountLevelAccessory: false,
                scannedItem: false,
                cashOptionEnabled: false,
                id: viewport() === 'mfapp' ? getCookie('routerSku') : getSession('routerSku'),
                offerId: viewport() === 'mfapp' ? getCookie('offerId') : getSession('offerId'),
                offerType: viewport() === 'mfapp' ? getCookie('offerType') : getSession('offerType'),
              },
            ],
            ispuFlow: false,
            depletionLocationCode: '',
          },
        ],
      },
    };
  }
  if (value.value === 'WHWExtender') {
    if (value?.incOrDec !== 'decrement') {
      addAccessories = [
        {
          qty: value?.qty,
          isSoftSku: false,
          accessoryBundle: false,
          giftCard: false,
          category: 'Gaming & Toys',
          productId: '',
          accountLevelAccessory: false,
          scannedItem: false,
          cashOptionEnabled: false,
          id: value?.routerSku,
          spoId: value?.spoId,
        },
      ];
    }

    if (value?.incOrDec === 'decrement' && value?.qty > window?.vzFlags?.whwBasicQuantity) {
      addAccessories = [
        {
          qty: window?.vzFlags?.whwBasicQuantity,
          isSoftSku: false,
          accessoryBundle: false,
          giftCard: false,
          category: 'Gaming & Toys',
          productId: '',
          accountLevelAccessory: false,
          scannedItem: false,
          cashOptionEnabled: false,
          id: value?.routerSku,
          spoId: value?.spoId,
        },
      ];
    }
    if (value?.incOrDec === 'decrement' && value?.qty <= window?.vzFlags?.whwBasicQuantity) {
      removeAccessories = [
        {
          qty: window?.vzFlags?.whwBasicQuantity,
          isSoftSku: false,
          accessoryBundle: false,
          giftCard: false,
          category: 'Gaming & Toys',
          productId: '',
          accountLevelAccessory: false,
          scannedItem: false,
          cashOptionEnabled: false,
          id: value?.routerSku,
          spoId: value?.spoId,
        },
      ];
    }
    postData = {
      cartInfo: {
        correlationId: '',
        processingMTN: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
        processStep: 'AccessoryPDP',
        cartCreator: '',
        processAction: 'addAccessoryAndCheckout',
        intendType: 'ACC',
        intent: `RedemptionAccessory`,
        creditAppNum: '',
        flowType: 'WHW_Redemption',
      },
      data: {
        depletionType: 'F',
        lines: [
          {
            mtn: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
            mdnFilterValue: '',
            addAccessories,
            removeAccessories,
            ispuFlow: false,
            depletionLocationCode: '',
          },
        ],
      },
    };
  }
  const apiURL = `${getSecureBaseUrl()}${apiUrls().addAccessories}`;
  return isWHW() || isWHWP2() ? HttpService.post(apiURL, postData, { headers: commonHeader }) : HttpService.post(apiURL, postData);
};
export const getAddYttv = (value) => {
  const add = value.addYtTv && [
    {
      itemId: value.addYtTv.prodId,
      name: value.addYtTv.name,
      actionIndicator: 'A',
      description: 'VIDEO',
      pricePlanId: value.addYtTv.pricePlanId,
      price: value.addYtTv.price,
      contentId: 'YTTVBASIC',
      recurringInd: value?.addYtTv?.recurringInd,
    },
  ];
  const remove = value.removeYtTv && [
    {
      itemId: value.removeYtTv.prodId,
      name: value.removeYtTv.name,
      description: 'VIDEO',
      pricePlanId: value.removeYtTv.pricePlanId,
      price: value.removeYtTv.price,
      contentId: 'YTTVBASIC',
      actionIndicator: 'Z',
      recurringInd: value?.removeYtTv?.recurringInd,
    },
  ];

  const postData = {
    cartInfo: {
      processAction: 'addAccessory',
      processingMTN: isJointTransactionFlow() || isECJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1',
      processStep: 'Accessories',
      cartCreator: '',
      intendType: `${getIntendType()}`,
      creditAppNum: '',
    },
    data: {
      isSubscription: true,
      account: {
        mcsSubscription: {
          add,
          remove,
        },
      },
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().addFeatures}`;
  return HttpService.post(apiURL, postData);
};
export const getReviewOrder = (data) => ({
  type: Constants.GET_REVIEW_ORDER,
  data,
});

export const resetProceedPage = (data) => ({
  type: Constants.RESET_PROCEED_FLOW,
  data,
});

export const reviewOrderCall = () => {
  const postData = {
    cartInfo: {
      clientAppName: 'VZW-DOTCOM',
      correlationId: '',

      accountNumber: '',
      cartCreator: '',
      processingMTN: '',
      locationCode: '',
      intendType: `${getIntendType()}`,
    },
  };
  if (isExpressCheckout()) {
    postData.cartInfo.processStep = 'ExpressCheckOut';
  }
  const apiURL = `${getSecureBaseUrl()}${apiUrls().validateOrder}`;
  return HttpService.post(apiURL, postData);
};

export const getDeviceSetup = (data) => {
  let postData = {};
  if (getAPPID() === 'AAL' && isBulkQualIndicator()) {
    postData = {
      cartInfo: {
        clientAppName: 'VZW-DOTCOM',
        bulkQualIndicator: 'Y',
        accountNumber: '',
        cartCreator: '',
        processingMTN: isECJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1',
        processStep: 'InstallType',
        processAction: 'updateInstallType',
        intendType: `${getIntendType()}`, // AEM variable LoggedInUserId & LQ Response : "launchType": "FCL"
        bundleInstallType: data.bundleInstallType,
      },
      data: {
        lines: [
          {
            depletionType: data.depletionType,
          },
        ],
      },
    };
  } else {
    postData = {
      cartInfo: {
        clientAppName: 'VZW-DOTCOM',

        accountNumber: '',
        cartCreator: '',
        processingMTN: isJointTransactionFlow() || isECJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1',
        processStep: 'InstallType',
        processAction: 'updateInstallType',
        streamLineFlow: `${skipProspectExpressCheckout()}`,
        intendType: `${getIntendType()}`, // AEM variable LoggedInUserId & LQ Response : "launchType": "FCL"
        bundleInstallType: data.bundleInstallType,
        ...(isJTFlowFromNGDCart() && { ngdJTCombo: true }),
      },
      data: {
        lines: [
          {
            depletionType: data.depletionType,
          },
        ],
      },
    };
  }
  postData.midnight = 'Y';

  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  return HttpService.post(apiURL, postData);
};

export const getVzProtectHome = (data) => {
  const joint = isJointTransactionFlow();
  const line = joint ? `${getJointTransactionLine()}` : 'newLine1';
  const add = data.addVZProtect && [
    {
      id: data.addVZProtect.prodId,
      actionIndicator: 'A',
      type: 'SPO',
      quantity: data.addVZProtect.qty,
      mtns: [
        {
          mtn: line,
        },
      ],
    },
  ];
  const numOfLines = data.removeVZProtect && data.removeVZProtect.numOfLines;
  let mtns;
  if (joint) {
    mtns = [
      {
        mtn: line,
      },
    ];
  } else if (numOfLines && numOfLines === '2') {
    mtns = [
      {
        mtn: 'newLine1',
      },
      {
        mtn: 'newLine2',
      },
    ];
  } else {
    mtns = [
      {
        mtn: 'newLine1',
      },
    ];
  }
  const remove = data.removeVZProtect && [
    {
      id: data.removeVZProtect.prodId,
      actionIndicator: 'D',
      type: 'SPO',
      quantity: data.removeVZProtect.qty,
      mtns,
    },
  ];

  const postData = {
    cartInfo: {
      correlationId: '',
      processingMTN: line,
      processStep: 'Accessories',
      processAction: 'addAccessory',
      cartCreator: '',
      intendType: `${getIntendType()}`, //'AAL_5G',
      creditAppNum: '',
    },
    data: {
      account: {
        features: {
          add,
          remove,
        },
      },
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().addFeatures}`;
  return HttpService.post(apiURL, postData);
};
const getFwhLines = (data, line, features) =>
  data?.addWHWPlan && (data?.addWHWPlan?.isDownGradeRedeem || data?.addWHWPlan?.upgradeOnly)
    ? [
        {
          mtn: line,
          features,
        },
      ]
    : [
        {
          mtn: line,
          features,
          accessories:
            (data?.prodName && !data?.prodName.toLowerCase().includes('plus')) ||
            data?.addWHWPlan?.pageName === 'displayShippingOptions' ||
            data?.addWHWPlan?.incrementButtonFlag === 'decrement'
              ? {
                  remove: [
                    {
                      qty: !isWHWP2() || data?.addWHWPlan?.isRedeemButton ? '2' : data.addWHWPlan.whwQty,
                      id: 'CE1000A',
                      category: !isWHWP2() && 'Home Services',
                    },
                  ],
                }
              : {
                  add: [
                    {
                      qty: !isWHWP2() || data?.addWHWPlan?.isRedeemButton ? '2' : data.addWHWPlan.whwQty,
                      id: 'CE1000A',
                      category: !isWHWP2() && 'Home Services',
                    },
                  ],
                },
        },
      ];

const generateCartInfo = (line, data, processAction) => ({
  correlationId: '',
  processingMTN: line,
  processStep: isWHWP2() && !data?.addWHWPlan?.isRedeemButton ? 'WHWRedemption' : 'Accessories',
  processAction: isWHWP2() && data?.addWHWPlan?.isDownGradeRedeem ? 'addFeatures' : processAction,
  cartCreator: '',
  intendType: isWHWP2() && !data?.addWHWPlan?.isRedeemButton ? 'FEA' : `${getIntendType()}`,
  intent: isWHWP2() && !data?.addWHWPlan?.isRedeemButton ? 'RedemptionAccessory' : `${getIntendType()}`,
  creditAppNum: '',
  flowType: isWHWP2() && 'WHW_Redemption',
});
export const getWHWPlan = (data) => {
  const joint = isJointTransactionFlow() || isECJointTransactionFlow();
  const processingMTN = viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN');
  const redemptionMDN = isWHWP2() ? processingMTN : 'newLine1';
  const redemptionLine = isWHWP2() && redemptionMDN ? redemptionMDN : 'newLine1';
  const line = joint ? `${getJointTransactionLine()}` : redemptionLine;
  const add = data.addWHWPlan && [
    {
      id: data.addWHWPlan.whwProdId,
      actionIndicator: data?.addWHWPlan?.isDownGradeRedeem ? 'D' : 'A',
      type: 'SPO',
      quantity: data.addWHWPlan.whwQty,
    },
  ];
  const remove = data.addWHWPlan && [
    {
      id: data.addWHWPlan.whwProdId,
      actionIndicator: 'A',
      type: 'SPO',
      quantity: data.addWHWPlan.whwQty,
    },
  ];
  const removeFeature = () => {
    let removeFeatureVal = false;
    if (isWHWP2()){
      if (data?.addWHWPlan?.incrementButtonFlag === 'decrement') {
        if (data?.addWHWPlan?.extenderCartData !== '2') {
          removeFeatureVal= true;
        }
      }
    }
    return removeFeatureVal;
  };
  const features =
    (!isWHWP2() && !data?.prodName?.toLowerCase().includes('plus')) ||
    data?.addWHWPlan?.pageName === 'displayShippingOptions' ||
    removeFeature() ||
    (data?.addWHWPlan?.isDownGradeRedeem === false && data?.addWHWPlan?.isUpgradeFlow === false)
      ? { remove }
      : { add };
  const lines = getFwhLines(data, line, features);
  const processAction = !data?.addWHWPlan?.isRedeemButton ? 'addFeaturesAndAccessory' : 'addAccessory';
  const postData = {
    cartInfo: generateCartInfo(line, data, processAction),
    data: {
      lines,
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().addFeatures}`;
  return HttpService.post(apiURL, postData);
};

export const getHomePhoneService = (data) => {
  const postData = buildHomePhoneServicePayload(data);
  if (getAPPID() === 'AAL' && isBulkQualIndicator()) {
    postData.cartInfo.bulkQualIndicator = 'Y';
  }
  postData.midnight = 'Y';

  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  return HttpService.post(apiURL, postData);
};
const buildHomePhoneServicePayload = (data) => ({
  cartInfo: {
    clientAppName: 'VZW-DOTCOM',
    correlationId: '',
    accountNumber: '',
    cartCreator: '',
    processingMTN: 'newLine2',
    processStep: 'Accessories',
    processAction: 'DeviceAndPlan',
    intendType: `${getIntendType()}`,
  },
  data: {
    lines: [
      {
        depletionType: 'F',
        depletionLocationCode: '',
        ispuFlow: false,
        isNewLine: true,
        mtn: 'newLine2',
        device: {
          deviceId: '',
          id: data.prodId,
          contractTerm: 'MONTH_TO_MONTH',
          dppMonths: '',
          isCustomerProvidedEquipment: false,
        },
        downPayment: {
          amount: '0.0',
        },
        e911Address: {
          address: {
            zipCode: data.zipCode,
            lastName: '',
            ruralDelNo: '',
            city: data.city,
            zipCode4: '',
            emailId: '',
            fipsCode: data.fipsCode,
            firstName: '',
            countryCode: '',
            addressLine1: data.addressLine1,
            attention: '',
            addressLine2: '',
            firmName: '',
            state: data.state,
          },
        },
        plan: {
          id: data.planId,
        },
      },
    ],
  },
});

export const removeHomePhone = () => {
  const postData = {
    cartInfo: {
      clientAppName: 'VZW-DOTCOM',
      creditAppNum: '',
      processingMTN: 'newLine2',
      processStep: 'ShoppingCart',
      intendType: `${getIntendType()}`,
      processAction: 'removeItem',
    },
    data: {
      lines: [
        {
          mtn: 'newLine2',
        },
      ],
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().removeHomePhone}`;
  return HttpService.post(apiURL, postData);
};

/**
 * used to integrate removeLines API.
 * @returns update cart API response.
 */
export const removeLines = () => {
  const flowType = getSession('FlowType');
  const postData = {
    cartInfo: {
      cartId: '',
      caseId: '',
      accountNumber: '',
      cartCreator: '',
      processingMTN: '',
      expressCheckout: 'true',
      processStep: 'PlanSelection',
      transactionType: 'WIFIBACKUP',
      intendType: getAPPID() === 'AAL' ? `AAL_${flowType}` : `NSE_${flowType}`,
    },
    data: {
      lines: [
        {
          mtn: getTransactionLine(),
          transactionType: 'WIFIBACKUP',
        },
      ],
    },
    validateCartRequest: {
      pageId: 'CART',
      retrieveCurrentFeatures: true,
    },
    expressCheckout: 'true',
  };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().removeHomePhone}`;
  return HttpService.post(apiURL, postData);
};

/**
 * used to integrate updatecart APi.
 * @param {request payload} data
 * @returns update cart API response.
 */
export const updateCart = (data) => {
  const qualificationResponseData = getLqDetails();
  const { wifiBackupCbandQualified = false } = qualificationResponseData;
  const { installType = '', processStep = '', processAction = '', transactionType = '' } = data;
  const cartCommonHeader = { flowName: `${getFlowTypeWithIntend(transactionType)}` };
  const getFlowIntendType = () => {
    let intendType = '';
    if (transactionType === wifiTransactionType) {
      if (getAPPID() === 'AAL') {
        intendType = wifiBackupCbandQualified ? 'AAL_5G' : 'AAL_LTE';
      } else {
        intendType = wifiBackupCbandQualified ? 'NSE_5G' : 'NSE_LTE';
      }
    } else {
      intendType = getAPPID() === 'AAL' ? `AAL_${flowType}` : `NSE_${flowType}`;
    }
    return intendType;
  };
  const flowType = getSession('FlowType');
  const processingMTN = isJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1';
  const isSequentialComboOrderFlow = showContactInfoForWifiBackupFFlag() && isSequentialFlow();
  console.log('data in update cart calling', data, flowType);
  const postData = {
    cartInfo: {
      clientAppName: 'VZW-DOTCOM',
      cartId: '',
      caseId: '',
      accountNumber: '',
      cartCreator: '',
      processingMTN: getAPPID() === 'AAL' ? processingMTN : '',
      processStep,
      processAction,
      intendType: getFlowIntendType(),
      bundleInstallType: installType,
      ...(isSequentialComboOrderFlow && { isSequentialComboOrder: 'true' }),
    },
    midnight: 'Y',
    data: {
      lines: [
        {
          depletionType: 'F',
        },
      ],
    },
  };
  if (transactionType) {
    postData.data.lines[0].transactionType = transactionType;
    postData.cartInfo.transactionType = transactionType;
  }
  if (data?.jointCombo) {
    postData.cartInfo.jointCombo = data.jointCombo;
  }

  const addLQResponseToCartInfo = () => {
    const lqResponse = getSession('LQResponse');
    if (!lqResponse) {
      return;
    }

    try {
      const lqResponseOutput = JSON.parse(lqResponse)?.output || {};
      const {
        recordIdentifier = '',
        addressLine1 = '',
        addressLine2 = '',
        city = '',
        state = '',
        zipCode = '',
        availableSpeedTier = '',
      } = lqResponseOutput;

      if (recordIdentifier) {
        postData.cartInfo.addressRecordIdentifier = recordIdentifier;
        postData.cartInfo.addressInfo = {
          addressLine1,
          addressLine2,
          city,
          state,
          zipCode,
          speedTier: availableSpeedTier,
        };
      }
    } catch (e) {
      logger(`Failed to parse LQResponse from session storage, ${e}`);
    }
  };
  addLQResponseToCartInfo();

  postData.midnight = 'Y';

  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  return HttpService.post(apiURL, postData, { headers: cartCommonHeader });
};

export const getValidateCart = (data, pageName, validCouponResponse, prefetchValidateCart) => ({
  type: Constants.GET_VALIDATE_ORDER,
  data,
  pageName,
  validCouponResponse,
  prefetchValidateCart,
});

export const validateCartCall = () => {
  const postData = {
    correlationId: '',

    accountNumber: '',
    cartCreator: '',
    processingMTN: '',
    locationCode: '',
    intendType: '',
    processStep: 'ShoppingCart',
    processAction: '',
    creditAppNum: '',
  };
  if (getAPPID() !== 'AAL') {
    postData.meta = { type: 'newCustomer' };
  }

  const apiURL = `${getSecureBaseUrl()}${apiUrls().validateCart}`;
  return HttpService.post(apiURL, postData);
};
export const getCheckoutDetailsApi = () => {
  const postData = {
    clientCorrelationId: '',
    customerTypeParam: null,
    optimizeSDD: 'N',
    cart: true,
    customerAgreements: false,
    installmentContracts: false,
    paymentOptions: true,
    shippingOptions: true,
    smsEnabledOptions: true,
    iconicFlags: {
      disableISPU: false,
      disableSDD: false,
      disableISAAC: false,
      disableEdgeUpISPUSDD: false,
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().getCheckoutDetailsurl}`;
  return HttpService.post(apiURL, postData);
};

export const saveCart = (emailId) => {
  const postData = {
    emailId,
    intendType: `${getIntendType()}`,
  };
  console.log(`${getSecureBaseUrl()}${apiUrls().saveCartURL}`);
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().saveCartURL}`, postData);
};

/**
 * Gets the streamLineFlow property object for AAL users in WHWP2 flow
 * @returns {object} Object with streamLineFlow property if AAL user, empty object otherwise
 */
export const getStreamLineFlowProperty = () => (getAPPID() === 'AAL' ? { streamLineFlow: isStreamlineFlow() || isJointTransactionFlow() || isSequentialFlow() } : {});

export const getUpdateCartAPI = (inputData) => {
  const bundleInfo = bundleInstallType();
  const action = inputData && 'actionType' in inputData ? inputData.actionType : '';
  let postData = {};
  if (!isMoversFlow() && !isWHWP2()) {
    if (getAPPID() === 'AAL' && isBulkQualIndicator()) {
      postData = getCartUpdtApiObj(bundleInfo, action);
      postData.cartInfo.bulkQualIndicator = 'Y';
    } else {
      postData = getCartUpdtApiObj(bundleInfo, action);
    }
  } else if (isWHWP2()) {
    const accountNumber = viewport() === 'mfapp' ? getCookie('accountNumber') : getSession('accountNumber');
    const customerId = viewport() === 'mfapp' ? getCookie('customerId') : getSession('customerId');
    postData = {
      cartInfo: {
        correlationId: '',
        processingMTN: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
        processStep: 'Initiate',
        cartCreator: '',
        processAction: 'RedemptionAccessory',
        intent: 'RedemptionAccessory',
        intendType: 'ACC',
        creditAppNum: '',
        flowType: 'WHW_Redemption',
        customerId,
        ...getStreamLineFlowProperty(),
        clientAppName: 'VZW-DOTCOM',
        accountNumber,
        action: window?.vzFlags?.isWHWPCartRestart ? 'Restart' : '',
      },
    };
  } else {
    postData = inputData;
  }

  postData.midnight = 'Y';
  const apiURL = `${getSecureBaseUrl()}${apiUrls().updateCartOnAddons}`;
  return HttpService.post(apiURL, postData);
};

export const updatePdc = (data) => ({
  type: Constants.ABANDON_CART_CALL,
  data,
});

export const abandonCartAPI = (data) => {
  const globalId = getCookie('GLOBALID');
  const sessionId = store?.getState()?.tagging?.channelSession;
  let postData = {};
  if (data?.pageName === 'orderSubmit' || data?.pageName === 'registration') {
    postData = {
      source: 'upsertSoi',
      topic: 'soi_fwa_digital_insights',
      serviceRequest: {
        globalId,
        insightCategory: 'vhiordering',
        insights: [
          {
            insightName: 'vzcart',
            insightValue: {
              e: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
              pageName: data?.pageName,
              smartCart: 'N',
              orderSubmitted: 'Y',
              sessionId,
            },
          },
        ],
      },
    };
  } else {
    postData = {
      source: 'upsertSoi',
      topic: 'soi_fwa_digital_insights',
      serviceRequest: {
        globalId,
        insightCategory: 'vhiordering',
        insights: [
          {
            insightName: 'vzcart',
            insightValue: {
              e: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
              pageName: data?.pageName,
              smartCart: 'Y',
              orderSubmitted: 'N',
              sessionId,
            },
          },
        ],
      },
    };
  }
  const apiURL = `${getSecureBaseUrl()}${apiUrls().abandonCart}`;
  return HttpService.post(apiURL, postData);
};

export const resetValidateCart = (data) => ({
  type: Constants.RESET_VALIDATE_CART,
  data,
});

export const validateCartNeeded = (data) => ({
  type: Constants.NEED_VALIDATE_CART,
  data,
});

export const quantityChanged = (data) => ({
  type: Constants.QUANTITY_CHANGED,
  data,
});

export const getShippingDetFromApi = (data, homePhone) => ({
  type: Constants.GET_SHIPPING_DET_FROM_API,
  data,
  homePhone,
});

export const updateProcessStepCart = () => ({
  type: Constants.UPDATE_PROCESS_STEP_CART,
});

export const updateProcessStepCartApi = () => {
  try {
    let postData = {};
    let apiResponse = '';
    postData = buildUpdateProcessStepPayload(getIntendType());
    apiResponse = HttpService.post(`${getSecureBaseUrl()}${apiUrls().updateProcessStepAddons}`, postData);
    Promise.all([apiResponse]).then((res) => res);
  } catch (error) {
    console.log('error in src/services/Cart/actions.js', error);
  }
};

// new Action for checking promo is valid or not
export const isCouponValid = (data, prodRef) => ({
  type: Constants.IS_COUPON_VALID,
  data,
  prodRef,
});

export const isCouponValidAPI = (data) => {
  const postData = {
    cartInfo: {
      clientAppName: 'VZW-DOTCOM',
      intendType: `${getIntendType()}`,
      processStep: isExpressCheckout() ? 'ExpressCheckOut' : 'ShoppingCart',
      processAction: 'addPromoCode',
    },
    data: {
      couponCode: data,
    },
  };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().isCouponValid}`;
  return HttpService.post(apiURL, postData);
};

// new Action for clearing valid coupon response
export const clearValidresponse = () => ({
  type: Constants.CLEAR_VALID_COUPON_RESPONSE,
});

export const triggerErrorNotification = () => ({
  type: Constants.ERORR_CART,
});

export const clearCouponvalue = () => ({
  type: Constants.CLEAR_COUPON_VALUE,
});

export const callSaveCartApi = (emailId) => ({
  type: Constants.UPDATE_SAVE_CART,
  data: emailId,
});

export const getMiniCartAPI = (data) => ({
  type: Constants.GET_MINI_CART,
  data,
});

export const getMiniCartData = (data = {}) => {
  const { pageName = '' } = data;
  try {
    const postData = buildCartPayload(pageName);

    return HttpService.post(`${getSecureBaseUrl()}${apiUrls().miniCart}`, postData);
  } catch (error) {}
};

export const buildCartPayload = (pageName, prefetchValidateCart) => {
  const cartData = store.getState()?.cartDetails;
  const prefetchOrderReview = cartData?.cartDetailsJson?.featureFlags?.prefetchOrderReviewFFlag;
  const flagEnabled = prefetchOrderReview || prefetchGetShippingOptionsCookie();
  const postData = {
    meta: {},
    data: { redesignFlow: true, availableSpoCategoryFilters: getBundleCategory(), validateCart: false },
    isPromoBadge: true,
  };
  if (pageName === 'orderConfirmation' || pageName === 'registration') {
    postData.data.orderPlaced = true;
  }
  if (
    whwFlag() &&
    ((flagEnabled &&
      prefetchConditions() &&
      window.location.href.includes('creditcheck') &&
      prefetchValidateCart === 'prefetechOrderReviewValCart') ||
      ((!prefetchOrderReview ||
        !prefetchGetShippingOptionsCookie() ||
        (prefetchOrderReview && parseFloat(cartData?.cartDetails?.cartDetailsJson?.orderDetailsView?.dueTodayAmount) > 0)) &&
        window.location.href.includes('orderreview')))
  ) {
    postData.data.validateCart = true;
  }

  return postData;
};

export const getCartDetailsForValidateCart = (data = {}) => {
  const { pageName = '' } = data;
  try {
    const postData = {
      meta: {},
      data: {
        validateCart: true,
        redesignFlow: true,
        validateAppointments: false,
        fetchUnifiedNbsData: false,
        availableSpoCategoryFilters: getBundleCategory(),
      },
      isPromoBadge: true,
    };

    if (pageName === 'cart') {
      if (getAPPID() === 'AAL') {
        postData.data.fetchUnifiedNbsData = true;
      }

      if (window.vzFlags.isValidateCartCall) {
        const isProfessionalSetup = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.installType === 'Professional SetUp';
        const validateAppointments = isProfessionalSetup && isAppointmentSetupEnabled();
        postData.data.validateAppointments = validateAppointments;
      }
    }

    return HttpService.post(`${getSecureBaseUrl()}${apiUrls().getCartDetailsurl}`, postData);
  } catch (error) {
    // Handle error if necessary
  }
};

export const getCheckoutDetails = () => {
  const postData = {
    processStack: '5g-checkout', //Identifier for the flow
    cartId: '', //Can be null this will be populated from Redis.
    disableSplitShipment: false, //Indicator to Enable disable split shipment only for shipping page
    optimizeSDD: 'Y', // Y
    expressCheckout: 'false', //Express Checkout flag for one page checkout false for FWA
    cart: true, //To get Cart Object as response
    customerAgreements: false, //To get the aggrements details as part of response
    installmentContracts: false, //To get Installment contract details from response ( false for fwa always)
    paymentOptions: true, // To get all available payment options (From Shipping Update,Load of Payment Page and Order Review)
    shippingOptions: false, // To get all available shipping Options
    smsEnabledOptions: false, // To get smsEnabled devices ( AAL, shipping page )
    iconicFlags: {
      // Iconic flags to disable the functionalities during LT.
      disableISPU: false,
      disableSDD: false,
      disableISAAC: false,
      disableEdgeUpISPUSDD: true,
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().getCheckoutDetailsurl}`;
  return HttpService.post(apiURL, postData);
};

export const addOrRemoveGiftCardAccessoryAPI = (data = {}) => {
  const joint = isJointTransactionFlow();
  const line = joint ? `${getJointTransactionLine()}` : 'newLine1';
  const postData = {
    cartInfo: {
      correlationId: '',
      cartCreator: '',
      processingMTN: line,
      processAction: 'addAccessory',
      processStep: 'Accessories',
      intendType: `${getIntendType()}`,
      intent: `${getIntendType()}`,
      gamingGiftCard: false,
      creditAppNum: '',
    },
    data: {
      depletionType: 'F',
      lines: [
        {
          mtn: line,
          mdnFilterValue: line,
          ...data,
          ispuFlow: false,
          depletionLocationCode: '',
        },
      ],
    },
  };

  const apiURL = `${getSecureBaseUrl()}${apiUrls().addAccessories}`;
  return HttpService.post(apiURL, postData);
};

export const updateBarCodeAPI = (nbxOfferId, BarCode, extraParams) => {
  const joint = isJointTransactionFlow();
  const line = joint ? `${getJointTransactionLine()}` : 'newLine1';
  const pageName = getUrlName(window.location.pathname);
  //TODO : for testing -- need to remove later
  const barCodeId = getQueryParamByName('barCodeId') || BarCode || '';
  const barCodeData = barCodeId
    ? {
        barCodeIds: [
          {
            barCodeId,
          },
        ],
      }
    : {};
  let processStep = 'ShoppingCart';
  if (pageName === 'expresscheckout') {
    processStep = 'ExpressCheckOut';
  } else if (pageName === 'progressiveplan' || pageName === 'streamlineordering') {
    processStep = 'PlanSelection';
  }
  const { processStep: processStepParam } = extraParams || {};
  if (processStepParam) {
    processStep = processStepParam;
  }
  const postData = {
    data: {
      lines: [
        {
          mtn: line,
        },
      ],
      includeExpiryBarcodeStatus: 'Y',
      nbxOfferId,
    },
    cartInfo: {
      cartId: '',
      caseId: '',
      accountNumber: '',
      cartCreator: '',
      // processAction: 'addBarCodeOffer',
      processAction: isExpressCheckout() ? 'ExpressCheckOut' : 'addBarCodeOffer',
      processStep,
      intendType: `${getIntendType()}`,
      ...barCodeData,
    },
  };

  const url = getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/updateBarcode' : '/cartservice/cart/5g/updateBarcode';
  return HttpService.post(`${getSecureBaseUrl()}${url}`, postData);
};

export const nbxOfferRecommendationsAPI = (pageContextValue) => {
  const postData = {
    source: 'fwaOfferRecommendations',
    pageContext: pageContextValue || 'FWA_ShoppingCart',
    category: '5GRouter',
  };
  const url =
    getAPPID() === 'NSE'
      ? '/personalizationrecommendationsservice/pdm/nse/fwaOfferRecommendations'
      : '/personalizationrecommendationsservice/pdm/fwaOfferRecommendations';
  return HttpService.post(`${getSecureBaseUrl()}${url}`, postData);
};

export const submitNBXFeedbackAPI = (postData) => {
  const apiURL = `${getSecureBaseUrl()}/devicepricingservice/acceptOffer/nbxFeedback`;
  return HttpService.post(apiURL, postData);
};

export const getFeatureFlagDetailAPI = (payload) => {
  const postData = {
      "featureFlagRequestInfos": [
          {
              "appName": payload.appName,
              "profileName": payload.profileName,
              "flagName": payload.flagName,
          },
      ],
  };
  const apiURL = getAPPID() === 'NSE' ? '/cartservice/cart/nse/5g/getFeatureFlags' : '/cartservice/cart/5g/getFeatureFlags';
  return HttpService.post(`${getSecureBaseUrl()}${apiURL}`, postData);
};

export const updateShowCart = (data) => ({
  type: 'UPDATE_SHOW_CART',
  data,
});
